import { useState, useEffect } from 'react';

/**
 * Hook for responsive media queries
 * @param {string} query - Media query string (e.g., "(min-width: 768px)")
 * @returns {boolean} Whether the media query matches
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);

    // Set initial value
    setMatches(media.matches);

    // Create listener
    const listener = (e) => setMatches(e.matches);

    // Add listener
    if (media.addEventListener) {
      media.addEventListener('change', listener);
    } else {
      // Fallback for older browsers
      media.addListener(listener);
    }

    // Cleanup
    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', listener);
      } else {
        media.removeListener(listener);
      }
    };
  }, [query]);

  return matches;
}

/**
 * Convenience hook for mobile detection
 * @returns {boolean} True if screen width is less than 768px
 */
export function useIsMobile() {
  return useMediaQuery('(max-width: 767px)');
}

export default useMediaQuery;
